import { Grid } from '@/common/grid/Grid';
import { useDependentKey } from '@/common/hooks/key/useDependentKey';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useRef, useState } from 'react';

export const UsAmpTable = ({ formValues, selectedDims }) => {

    const { subPeriodId } = formValues;

    const gridRef = useRef();
    
    const rsrc = useRsrc();

    const [data, setData] = useState();

    const [fieldDefs, setFieldDefs] = useState();
    const [isGridReady, setIsGridReady] = useState(false);

    useEffect(() => {
        rsrc.data('sc', 'US_AMP_TABLE_FIELD_DEFS_DATA_PLUGIN', {}).then(res => {
            setFieldDefs(res);
        });
    }, []);

    useEffect(() => {
        if (!subPeriodId) {
            return;
        }

        const reqParam = {
            subPeriodId,
            dims: selectedDims
        };

        rsrc.data('sc', 'US_AMP_TABLE_DATA_PLUGIN', reqParam).then(res => {
            setData(res);
        });
    }, [subPeriodId, selectedDims]);

    const onGridReady = () => {
        setIsGridReady(true);
    }

    useEffect(() => {
        if (isGridReady && gridRef.current && data) {
            gridRef.current.setDataSource(data);
        }
    }, [isGridReady, data]);

    const gridKey = useDependentKey(fieldDefs);

    if (!fieldDefs || !data) {
        return;
    }

    return (
        <Grid 
            key={gridKey}
            ref={gridRef}
            gridOptions={{
                fieldDefs,
                rowModelType: 'clientSide',
                statusBar: null
            }}
            events={{ onGridReady }}
        />
    );

}